import React from "react";
import styled from "styled-components";
import Loading from "@ui-kit/loading";

const Wrapper = styled.div`
  position: relative;
  height: 400px;
`;

export const NavigationSwitcherLoading = () => {
  return (
    <Wrapper>
      <Loading />
    </Wrapper>
  );
};

export default NavigationSwitcherLoading;
